import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective
} from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatDatepickerModule,
  MatIconModule,
  MatInputModule,
  MatNativeDateModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatTooltipModule,
  MatCheckboxModule,
  MatExpansionModule, MatCardModule
} from '@angular/material';
import {
  OrganizationsAutocompleteComponent
} from './components/organizations-autocomplete/organizations-autocomplete.component';
import {CitiesAutocompleteComponent} from './components/cities-autocomplete/cities-autocomplete.component';
import {CountriesAutocompleteComponent} from './components/countries-autocomplete/countries-autocomplete.component';
import {UsersPartnerAutocompleteComponent} from './components/users-partner-autocomplete/users-partner-autocomplete.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PhotoBlockComponent} from './components/photo-block/photo-block.component';
import {AgenciesAutocompleteComponent} from './components/agencies-autocomplete/agencies-autocomplete.component';
import {PermissionsSelectorComponent} from './components/permissions-selector/permissions-selector.component';
import {RolesAutocompleteComponent} from './components/roles-autocomplete/roles-autocomplete.component';
import {CallCentersAutocompleteComponent} from './components/call-centers-autocomplete/call-center-autocomplete.component';
import {UsersClkAutocompleteComponent} from './components/users-clk-autocomplete/users-clk-autocomplete.component';
import { DialogMessagesComponent } from './dialog-messages/dialog-messages.component';
import { ReportFormComponent } from './components/report-form/report-form.component';
import { HasPermissionDirective } from './directives/has-permission/has-permission.directive';
import { MonetaryAreasAutocompleteComponent } from './components/monetary-areas-autocomplete/monetary-areas-autocomplete.component';
import {ShowOperationBlockComponent} from './components/show-operation-block/show-operation-block.component';
import { PrintOperationComponent } from './components/print-operation/print-operation.component';
import { OperationReasonComponent } from './components/operation-reason/operation-reason.component';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { RegexpInputCheckDirective } from './directives/regexp-input-check/regexp-input-check.directive';
import { OperationIdentityComponent } from './components/operation-identity/operation-identity.component';
import { MenuItems } from './menu-items/menu-items';
import { DeleteConfirmationDialogComponent } from './components/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { PlatformAutocompleteComponent } from './components/platform-autocomplete/platform-autocomplete.component';
import { AppColorDirective } from './directives/app-color/app-color.directive';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import {UserLogsService} from './components/user-logs/user-logs.service';
import {UserLogsComponent} from './components/user-logs/user-logs.component';
import {NgxDatatableModule} from'@swimlane/ngx-datatable';
import { SlidePanelComponent } from "./components/slide-panel/slide-panel.component";

import { CurrencyFormatPipePipe } from './pipes/CurrencyFormatPipe/currency-format-pipe.pipe';
import { CurrencyFormatDirectiveDirective } from './directives/CurrencyFormatDirective/currency-format-directive.directive';
import { UserLogsDialogComponent } from './components/user-logs/user-logs-dialog/user-logs-dialog.component';
import { CollectSubUserPermissionsAutocompleteComponent } from './components/collect-sub-user-permissions-autocomplete/collect-sub-user-permissions-autocomplete.component';
import { FreezeConfirmationDialogComponent } from './components/freeze-confirmation-dialog/freeze-confirmation-dialog.component';
import { ResponseDialogComponent } from './components/response-dialog/response-dialog.component';
import { CollectAgenciesAutocompleteComponent } from './components/collect-agencies-autocomplete/collect-agencies-autocomplete.component';
import { CollectProductsAutocompleteComponent } from './components/collect-products-autocomplete/collect-products-autocomplete.component';
import { CommissionAccountComponent } from './components/commission-account-autocomplete/commission-account-autocomplete.component';
import { AlertConfirmationComponent } from './components/alert-confirmation/alert-confirmation.component';
import { CancelConfirmationDialogComponent } from './components/cancel-confirmation-dialog/cancel-confirmation-dialog.component';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatCheckboxModule,
    NgxDatatableModule,
    MatCardModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    UsersPartnerAutocompleteComponent,
    UsersClkAutocompleteComponent,
    OrganizationsAutocompleteComponent,
    CitiesAutocompleteComponent,
    CountriesAutocompleteComponent,
    AgenciesAutocompleteComponent,
    RolesAutocompleteComponent,
    CallCentersAutocompleteComponent,
    PhotoBlockComponent,
    PermissionsSelectorComponent,
    DialogMessagesComponent,
    ReportFormComponent,
    HasPermissionDirective,
    MonetaryAreasAutocompleteComponent,
    ShowOperationBlockComponent,
    PrintOperationComponent,
    ChangePasswordDialogComponent,
    OperationReasonComponent,
    RegexpInputCheckDirective,
    OperationIdentityComponent,
    DeleteConfirmationDialogComponent,
    PlatformAutocompleteComponent,
    AppColorDirective,
    SafeHtmlPipe,
    UserLogsComponent,
    SlidePanelComponent,
    CurrencyFormatPipePipe,
    CurrencyFormatDirectiveDirective,
    UserLogsDialogComponent,
    CollectSubUserPermissionsAutocompleteComponent,
    FreezeConfirmationDialogComponent,
    ResponseDialogComponent,
    CollectAgenciesAutocompleteComponent,
    CollectProductsAutocompleteComponent,
    CommissionAccountComponent,
    AlertConfirmationComponent,
    CancelConfirmationDialogComponent,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    UsersPartnerAutocompleteComponent,
    UsersClkAutocompleteComponent,
    OrganizationsAutocompleteComponent,
    CitiesAutocompleteComponent,
    CountriesAutocompleteComponent,
    AgenciesAutocompleteComponent,
    RolesAutocompleteComponent,
    CallCentersAutocompleteComponent,
    PhotoBlockComponent,
    PermissionsSelectorComponent,
    ReportFormComponent,
    MonetaryAreasAutocompleteComponent,
    ShowOperationBlockComponent,
    PrintOperationComponent,
    OperationReasonComponent,
    HasPermissionDirective,
    RegexpInputCheckDirective,
    OperationIdentityComponent,
    DeleteConfirmationDialogComponent,
    PlatformAutocompleteComponent,
    AppColorDirective,
    SafeHtmlPipe,
    UserLogsComponent,
    SlidePanelComponent,
    CurrencyFormatPipePipe,
    CurrencyFormatDirectiveDirective,
    UserLogsDialogComponent,
    CollectSubUserPermissionsAutocompleteComponent,
    FreezeConfirmationDialogComponent,
    ResponseDialogComponent,
    CollectAgenciesAutocompleteComponent,
    CollectProductsAutocompleteComponent,
    CommissionAccountComponent,
    AlertConfirmationComponent,
    CancelConfirmationDialogComponent
   ],
  entryComponents: [
    DeleteConfirmationDialogComponent,
    UserLogsDialogComponent,
    FreezeConfirmationDialogComponent,
    ResponseDialogComponent,
    AlertConfirmationComponent,
    CancelConfirmationDialogComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    MenuItems,
    UserLogsService,
    CurrencyFormatPipePipe
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts